// extracted by mini-css-extract-plugin
module.exports = {"carousel_3d_controls":"Controls_carousel_3d_controls__4nsWE","carousel_3d_controls_disabled":"Controls_carousel_3d_controls_disabled__OOEC5"};